export const isA11yClick = ({ type, keyCode }) => type === 'click' || (type === 'keydown' && (keyCode === 32 || keyCode === 13));
